import Form from '../../Atoms/Form'
import Svg from '../../Atoms/Svg'
import TextLink from '../../Atoms/TextLink'
import Typography from '../../Atoms/Typography'
import Button from '../../Molecules/Button'
import { useUserStore } from '../../Stores/UserStore/UserStore'
import { createClickedSegmentEvent } from '../../Utilities/Instrumentation/Impressions/impressionSegmentEvents'
import { validateZip } from '../../Utilities/Location/Location'
import styles from './ZipCodeInput.module.scss'

import { useState } from 'react'

const ZipCodeInput = () => {
  const zipCode = useUserStore((x) => x.context.zipCode)
  const updateUserZipCode = useUserStore((x) => x.updateUserZipCode)

  const [enteringZip, setEnteringZip] = useState(false)
  const [error, setError] = useState(null)

  const submit = (e) => {
    e.preventDefault()
    const value = e.nativeEvent?.target[0]?.value ?? null
    var [zip, isZipValid] = validateZip(value)
    if (isZipValid) {
      updateUserZipCode(zip)
      setEnteringZip(false)
      setError(null)
    } else {
      setError('Please enter a 5 digit ZIP code')
    }
  }

  if (enteringZip) {
    return (
      <>
        <Form onSubmit={submit} className={styles.form}>
          <div className={styles.container}>
            <Form.Textbox hideSpinner autoFocus type={'number'} fill></Form.Textbox>
            <Button
              size={'small'}
              className={styles.switchLabel}
              invert
              intent={'action'}
              type={'submit'}
              segmentEvent={createClickedSegmentEvent('SubmitZipCodePrp')}
            >
              <Svg icon={'check'} size={1} />
            </Button>
          </div>
          <Typography size={0.875} intent={'negative'}>
            {error}
          </Typography>
        </Form>
      </>
    )
  } else if (!zipCode) {
    return (
      <>
        <Svg icon={'trackorder'} size={1} />{' '}
        <TextLink intent={'action'} onClick={() => setEnteringZip(true)} className={styles.switchLabel} size={0.875}>
          Get Shipping Estimates
        </TextLink>
      </>
    )
  } else {
    return (
      <>
        <TextLink
          intent={'action'}
          className={styles.container}
          onClick={() => {
            setEnteringZip(true)
          }}
          size={0.875}
          dataTesting={'sidebar_zipcode'}
        >
          <Svg icon={'trackorder'} size={1} />
          <Typography intent={'action'} className={styles.switchLabel} size={0.875}>
            Shipping to {zipCode}
          </Typography>
        </TextLink>
      </>
    )
  }
}

export default ZipCodeInput
